import React from 'react';
import Clock from '../assets/images/clock.svg';

export default () => {
  return <img src={Clock} alt="" />;
};
